import { Component, inject, output } from '@angular/core';
import { AsyncPipe, NgOptimizedImage } from '@angular/common';
import { Observable } from 'rxjs';
import { SearchService } from 'src/app/shared/services/search.service';
import { SearchResult, SearchResults } from 'src/app/shared/interfaces/search-results.interface';
import { RouterLink } from '@angular/router';
import { AnalyticsService } from 'src/app/core/services/analytics.service';
import { AnalyticsEventName } from 'src/app/core/enums/analytics.enum';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-search-results',
  imports: [
    AsyncPipe,
    NgOptimizedImage,
    RouterLink,
    TranslocoPipe,
  ],
  templateUrl: './search-results.component.html',
  styleUrl: './search-results.component.scss'
})
export class SearchResultsComponent {
  private readonly analyticsService = inject(AnalyticsService);
  protected readonly searchService = inject(SearchService);

  protected readonly searchResults$: Observable<SearchResults | null> = this.searchService.searchResults$;
  
  protected readonly itemSelected = output<void>();

  protected handleMachineClick(machine: SearchResult): void {
    this.analyticsService.trackEvent(AnalyticsEventName.ItemClick, {
      screenName: 'search',
      itemId: 'search_result',
      itemName: 'search_result',
      jcbMachineId: machine.id,
      jcbMachineName: machine.title,
      jcbRangeId: machine.rangeId,
      jcbRangeName: machine.rangeTitle,
    });
    
    this.itemSelected.emit();
  }

  protected handleRangeClick(range: SearchResult): void {
    this.analyticsService.trackEvent(AnalyticsEventName.ItemClick, {
      screenName: 'search',
      itemId: 'search_result',
      itemName: 'search_result',
      jcbRangeId: range.id,
      jcbRangeName: range.title,
    });
    
    this.itemSelected.emit();
  }
}
